function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26,48h-2c-0.552,0-1-0.447-1-1v-1.675c0-3.353-3.136-6.316-6.316-7.377C16.275,37.813,16,37.431,16,37l0,0c0-0.553,0.448-1,1-1h16c0.553,0,1,0.447,1,1l0,0c0,0.431-0.275,0.813-0.684,0.948C30.137,39.01,27,41.974,27,45.325V47C27,47.553,26.553,48,26,48z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M9.5 47L40.5 47"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25,2C15.626,2,8,9.626,8,19c0,6.489,3.658,12.136,9.017,15h15.966C38.342,31.136,42,25.489,42,19C42,9.626,34.374,2,25,2z M26,30c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1s1,0.448,1,1C27,29.552,26.552,30,26,30z M28,26c0-0.552,0.448-1,1-1s1,0.448,1,1c0,0.552-0.448,1-1,1S28,26.552,28,26z M30,31c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1s1,0.448,1,1C31,30.552,30.552,31,30,31z M31,23c0-0.552,0.448-1,1-1s1,0.448,1,1c0,0.552-0.448,1-1,1S31,23.552,31,23z M33,28c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1s1,0.448,1,1C34,27.552,33.552,28,33,28z M34,20c0-0.552,0.448-1,1-1s1,0.448,1,1c0,0.552-0.448,1-1,1S34,20.552,34,20z M36,25c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1s1,0.448,1,1C37,24.552,36.552,25,36,25z"
});

function SvgGolf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolf);
export default __webpack_public_path__ + "static/media/golf.149a8f36.svg";
export { ForwardRef as ReactComponent };